const initialState = null;
const initialStateForTest = null;

export default initialState;
export { initialStateForTest };
